'use strict';

import { axios } from '@src/lib/axios';

export const fetchHomepageItems = async ({ pageSize = 12, pageNumber = 1 } = {}) => {
    const { data } = await axios.get('/api/homepage/items', {
        params: { pageSize, pageNumber }
    });
    return data.data;
};

export const fetchUserWishlist = async () => {
    const { data } = await axios.get('/api/user/wishlist');
    return data.data;
};
